import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Badge } from '@shared/ui/Badge';
import { Field, Input, Select } from '@shared/ui/Input';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: ${({ theme }) => theme.spacing(5)};
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const CheckRow = styled.button<{ $active?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) =>
    $active ? theme.colors.primarySoft : theme.colors.backgroundElevated};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.spacing(3)};
  font: inherit;
  color: inherit;
  transition: border-color 120ms ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }
`;

export const ObjName = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const Muted = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: ${({ theme }) => theme.spacing(2)};

  th,
  td {
    text-align: left;
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(2.5)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: top;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.colors.text.muted};
  }

  td.num {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;

export const TableTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-top: ${({ theme }) => theme.spacing(5)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const FileHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const Err = styled.div`
  color: ${({ theme }) => theme.colors.status.danger};
  font-size: 13px;
`;

export const CrossLink = styled(Link)`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const NarrowInput = styled(Input)`
  width: 150px;
`;

export const CheckLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
  white-space: nowrap;
  cursor: pointer;
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const FieldZero = styled(Field)`
  margin: 0;
`;

export const FieldSelect = styled(Field)`
  margin: 0;
  flex: 1;
  min-width: 200px;
`;

export const FieldSelectWide = styled(Field)`
  margin: 0;
  flex: 1;
  min-width: 240px;
`;

export const FormRow = styled(Row)`
  flex-wrap: wrap;
`;

export const FormSelect = styled(Select)`
  flex: 1;
  min-width: 220px;
`;

export const ThCheckbox = styled.th`
  width: 28px;
`;

export const ThRight = styled.th`
  text-align: right !important;
`;

export const TableTitleZero = styled(TableTitle)`
  margin-top: 0;
`;

export const InlineBadge = styled(Badge)`
  margin-left: 6px;
`;

export const FiltersMargin = styled(Filters)`
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

export const SubmitWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

export const SubmitWrapperSm = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const MutedMargin = styled(Muted)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const ErrMargin = styled(Err)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const UploadErrorText = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1)};
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.status.danger};
  max-width: 340px;
  word-break: break-word;
`;
